import {BaseEntity} from "./BaseEntity";
import {IVTag} from "./IVTag";
import {ApplicationSetting} from "./ApplicationSetting";

export class Asset implements BaseEntity, IVTag {
    constructor(public id?:number,
                public name?:string,
                public description?:string,
                public rfidTag?:string,
                public vTagID?:string,
                public vTagGpsDeviceID?:string,
                public vTagGpsAppKey?:string,
                public deviceRegistered:boolean = false,
                public assetType?:string,
                public departmentCode?:string,
                public maxUnseenTime?:number,
                public lastObservedLocation?:string,
                public lastObservedTime?:string,
                public checkinStatus:string = "Checked In",
                public checkedOutTo?:string,
                public additionalInformation?:string,
                public locationID?:number,
                public disposalStatus:string = "In Service",
                public disposalMethod?:string,
                public disposalDate?:Date,
                public disposalDestination?:string,
                public maintenanceStartDate?:Date,
                public maintenanceSingleDate?:Date,
                public nextMaintenance?:Date,
                public date1?:Date,
                public date2?:Date,
                public date3?:Date,
                public date4?:Date,
                public date5?:Date,
                public listValue1?:string,
                public listValue2?:string,
                public listValue3?:string,
                public listValue4?:string,
                public listValue5?:string,
                public text1?:string,
                public text2?:string,
                public text3?:string,
                public text4?:string,
                public text5?:string,
                public text6?:string,
                public text7?:string,
                public text8?:string,
                public text9?:string,
                public text10?:string,
                public text11?:string,
                public text12?:string,
                public text13?:string,
                public text14?:string,
                public text15?:string,
                public text16?:string,
                public text17?:string,
                public text18?:string,
                public text19?:string,
                public text20?:string,
                public locationName?:string,
                public locationSite?:string,
                public locationBuilding?:string,
                public locationFloor?:string,
                public locationRoom?:string,
                public locationDescription?:string,
                public maintenanceMethod:string="No Maintenance",
                public maintenanceIntervalMonths?:number,
                public vTagX?:number,
                public vTagY?:number,
                public vTagZ?:number,
                public latitude?:number,
                public longitude?:number,
                public altitude?:number,
                public numberOfSatellites?:number,
                public lastGPSFix?:string,
                public gpsAccuracy?:string,
                public missedSatelliteFixes?:number,
                public parentVTag?:string,
                public vTagType?:string,
                public vTagPositionType?:string,
                public vTagFixedRelay?:boolean,
                public vTagAccelSensor?:boolean,
                public vTagBoxX?:number,
                public vTagBoxY?:number,
                public vTagBoxWidth?:number,
                public vTagBoxHeight?:number,
                public vTagAlgorithmType?:string,
                public vTagLastSeen?:string,
                public vTagLastMoved?:string,
                public batteryLevel?:string,
                public nearestFixed?:string,
                public nearestFixedName?:string,
                public lastModified?:string,
                public created?:string,
                public sensorReadingHistoryID?:number,
                public alertingActionID?:number,
                public sensorStatsHistoryID?:number,
                public assetParentID?:number,
                public assetChildCount?:number,
                public readerID?:number,
                public fileDataID?:number,
                public batteryVolts?:number,
                public lastModifiedBy?:string,
                public lastInventoried?:string) {
    }
    isActiveTag(minutes:number){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.vTagLastSeen == null ? Date.now() : Date.parse(this.vTagLastSeen);
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        //console.log("Asset - tag "+this.vTagID+" lastSeen="+this.vTagLastSeen+" and diffMinutes="+diffMinutes+" and minutes="+minutes);
        if(diffMinutes > minutes)
            return false;
        else
            return true;
    }
    isRecentlyActive(){
        var nowDate:number = Date.now();
        var lastMovedDate:number = this.vTagLastMoved == null ? Date.now() : Date.parse(this.vTagLastMoved);
        var diffDate:number = nowDate - lastMovedDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        if(diffMinutes < 5)
            return true;
        else
            return false;
    }
    search(txt:string):boolean{
        if(txt == null || txt.length == 0)
            return true;
        var search:string = txt.toLowerCase();
        if(this.name != null && this.name.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.description != null && this.description.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.rfidTag != null && this.rfidTag.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.vTagID != null && this.vTagID.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text1 != null && this.text1.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text2 != null && this.text2.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text3 != null && this.text3.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text4 != null && this.text4.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text5 != null && this.text5.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text6 != null && this.text6.toLowerCase().indexOf(search) != -1)
            return true;3
        if(this.text7 != null && this.text7.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text8 != null && this.text8.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text9 != null && this.text9.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text10 != null && this.text10.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text11 != null && this.text11.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text12 != null && this.text12.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text13 != null && this.text13.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.text14 != null && this.text14.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationName != null && this.locationName.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationSite != null && this.locationSite.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationBuilding != null && this.locationBuilding.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationFloor != null && this.locationFloor.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationRoom != null && this.locationRoom.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationDescription != null && this.locationDescription.toLowerCase().indexOf(search) != -1)
            return true;
        /*
        //if(this.date1 != null && this.date1.toLowerCase().indexOf(search) != -1)
        //    return true;
        if(this.date2 != null && this.date2.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.date3 != null && this.date3.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.date4 != null && this.date4.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.date5 != null && this.date5.toLowerCase().indexOf(search) != -1)
            return true;
        */
        if(this.listValue1 != null && this.listValue1.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.listValue2 != null && this.listValue2.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.listValue3 != null && this.listValue3.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.listValue4 != null && this.listValue4.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.listValue5 != null && this.listValue5.toLowerCase().indexOf(search) != -1)
            return true;
        return false;
    }

    parseJson(json:any):void{
        var dateFormat = ApplicationSetting.applicationSetting.dateFormat;
        this.id  = json.id;
        this.name = json.name;
        this.description = json.description,
            this.rfidTag = json.rfidTag,
            this.vTagID = json.vTagID,
            this.vTagGpsDeviceID = json.vTagGpsDeviceID,
            this.vTagGpsAppKey = json.vTagGpsAppKey,
            this.deviceRegistered = json.deviceRegistered == null ? false : json.deviceRegistered,
            this.assetType = json.assetType,
            this.departmentCode = json.departmentCode,
            this.maxUnseenTime = json.maxUnseenTime,
            this.lastObservedLocation = json.lastObservedLocation,
            this.lastObservedTime = json.lastObservedTime ;//== null ? "" :  moment(json.lastObservedTime).format(dateFormat),
        this.checkinStatus = json.checkinStatus,
            this.checkedOutTo = json.checkedOutTo,
            this.additionalInformation = json.additionalInformation,
            this.locationID = json.locationID,
            this.disposalStatus = json.disposalStatus,
            this.disposalMethod = json.disposalMethod,
            this.disposalDate = json.disposalDate == null ? null : new Date(json.disposalDate),
            this.disposalDestination = json.disposalDestination,
            this.maintenanceStartDate = json.maintenanceStartDate == null ? null : new Date(json.maintenanceStartDate),
            this.maintenanceSingleDate = json.maintenanceSingleDate == null ? null : new Date(json.maintenanceSingleDate),
            this.nextMaintenance = json.nextMaintenance == null ? null : new Date(json.nextMaintenance),
            this.date1 = json.date1== null ? null : new Date(json.date1);
        this.date2 = json.date2== null ? null : new Date(json.date2);
        this.date3 = json.date3== null ? null : new Date(json.date3);
        this.date4 = json.date4== null ? null : new Date(json.date4);
        this.date5 = json.date5== null ? null : new Date(json.date5);
        this.listValue1 = json.listValue1,
            this.listValue2 = json.listValue2,
            this.listValue3 = json.listValue3,
            this.listValue4 = json.listValue4,
            this.listValue5 = json.listValue5,
            this.text1= json.text1,
            this.text2 = json.text2,
            this.text3=json.text3,
            this.text4 = json.text4,
            this.text5 = json.text5,
            this.text6 = json.text6,
            this.text7 = json.text7,
            this.text8 = json.text8,
            this.text9 = json.text9,
            this.text10 = json.text10,
            this.text11 = json.text11,
            this.text12 = json.text12,
            this.text13 = json.text13,
            this.text14 = json.text14,
            this.text15 = json.text15,
            this.text16 =json.text16,
            this.text17 = json.text17,
            this.text18 = json.text18,
            this.text19 = json.text19,
            this.text20 = json.text20,
            this.locationName = json.locationName,
            this.locationSite = json.locationSite,
            this.locationBuilding = json.locationBuilding,
            this.locationFloor = json.locationFloor,
            this.locationRoom = json.locationRoom,
            this.locationDescription = json.locationDescription,
            this.maintenanceMethod = json.maintenanceMethod == null ? "No Maintenance":json.maintenanceMethod,
            this.maintenanceIntervalMonths = json.maintenanceIntervalMonths,
            this.vTagX = json.vTagX,
            this.vTagY = json.vTagY,
            this.vTagZ = json.vTagZ,
            this.latitude= json.latitude,
            this.longitude = json.longitude,
            this.altitude = json.altitude,
            this.numberOfSatellites = json.numberOfSatellites,
            this.missedSatelliteFixes = json.missedSatelliteFixes,
            this.parentVTag = json.parentVTag,
            this.lastGPSFix = json.lastGPSFix,
            this.gpsAccuracy = json.gpsAccuracy,
            this.vTagType = json.vTagType,
            this.vTagPositionType = json.vTagPositionType,
            this.vTagFixedRelay = json.vTagFixedRelay,
            this.vTagAccelSensor = json.vTagAccelSensor,
            this.vTagBoxX = json.vTagBoxX,
            this.vTagBoxY = json.vTagBoxY,
            this.vTagBoxWidth = json.vTagBoxWidth,
            this.vTagBoxHeight = json.vTagBoxHeight,
            this.vTagAlgorithmType = json.vTagAlgorithmType,
            this.vTagLastSeen = json.vTagLastSeen;// == null ? "" :  moment(json.vTagLastSeen).format(dateFormat),
        this.vTagLastMoved = json.vTagLastMoved;// == null ? "" :  moment(json.vTagLastMoved).format(dateFormat),
        this.batteryLevel = json.batteryLevel != null ? json.batteryLevel.toFixed(2) : null,
            this.nearestFixed = json.nearestFixed,
            this.lastModified = json.lastModified;// == null ? "" :  moment(json.lastModified).format(dateFormat),
        this.created = json.created;// == null ? "" :  moment(json.created).format(dateFormat),
        this.lastInventoried = json.lastInventoried;
        this.sensorReadingHistoryID = json.sensorReadingHistoryID,
            this.alertingActionID = json.alertingActionID,
            this.sensorStatsHistoryID = json.sensorStatsHistoryID,
            this.readerID = json.readerID,
            this.fileDataID = json.fileDataID,
            this.batteryVolts = json.batteryVolts,
            this.assetParentID = json.assetParentID,
            this.assetChildCount = json.assetChildCount;
        this.lastModifiedBy = json.lastModifiedBy;
        // Modified 01/31/19 by BA - Added nearest fixed name property
        this.nearestFixedName = json.nearestFixedName;
    }
    hasVTagData(){
        //console.log("a.name="+this.name+". vtagx="+this.vtagx+",vtagy="+this.vtagy+",vtpos="+this.vTagPositionType);
        if(this.vTagX != null && this.vTagY != null && this.vTagPositionType != null && this.vTagPositionType.length > 0)
            return true;
        else if (this.latitude != null && this.longitude != null && this.vTagType == "VTag GPS")
            return true;
        else
            return false;
    }
}
